import React from 'react';
import PropTypes from 'prop-types';
import { UX2 } from '@wsb/guac-widget-core';
import CarouselThumbs from '../../shared/Carousel/CarouselThumbs';
import DesktopAssets from './DesktopAssets';
import getStyles from './getStyles';
import { getImageRatio } from '../../utils/ProductUtils';
import useDevice, { devices } from '../../../hooks/useDevice';

function Classic(props) {
  const { Block } = UX2.Element;
  const styles = getStyles(props);
  const [device] = useDevice();

  return (
    <Block>
      <Block style={ styles.wrapperDesktop }>
        <Block style={ styles.imageWrapper }>
          <Block style={ styles.imageOuter }>
            <DesktopAssets
              selectedAsset={ props.selectedAsset }
              product={ props.product }
              zoomConfig={{
                disableZoom: !props.zoomEnabled,
                containerStyle: {
                  position: 'relative',
                  height: '400px'
                },
                enlargedImagePosition: 'over',
                cropMethod: props.pdpImageCropMethod
              }}
              aspectRatio={ getImageRatio(props.pdpImageShape, props.pdpLayout) }
              isQuickView={ props.isQuickView }
            />
          </Block>
        </Block>
      </Block>
      <CarouselThumbs
        { ...props }
        assetsVisible={ device === devices.TABLET ? 4 : props.assetsVisible }
      />
    </Block>
  );
}

Classic.propTypes = {
  assets: PropTypes.array,
  hasFinalizedAssets: PropTypes.bool,
  isCurrentAsset: PropTypes.func,
  onClickThumbnail: PropTypes.func,
  pdpImageCropMethod: PropTypes.string,
  product: PropTypes.object,
  selectedAsset: PropTypes.object,
  translate: PropTypes.func,
  zoomEnabled: PropTypes.bool,
  pdpImageShape: PropTypes.string,
  pdpLayout: PropTypes.string.isRequired,
  assetsVisible: PropTypes.number,
  isQuickView: PropTypes.bool
};

export default Classic;
